export const MAX_AD_AGE_IN_DAYS = 30;
